(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import ajSrc from "../../assets/images/countries/aj.svg";
import bgSrc from "../../assets/images/countries/bg.svg";
import bhSrc from "../../assets/images/countries/bh.svg";
import etSrc from "../../assets/images/countries/et.svg";
import euSrc from "../../assets/images/countries/eu.svg";
import gnSrc from "../../assets/images/countries/gn.svg";
import ngSrc from "../../assets/images/countries/ng.svg";
import cgSrc from "../../assets/images/countries/cg.svg";
import joSrc from "../../assets/images/countries/jo.svg";
import npSrc from "../../assets/images/countries/np.svg";
import adSrc from "../../assets/images/countries/ad.svg";
const countryMap = {
  bj: bgSrc,
  ng: ngSrc,
  et: etSrc,
  eu: euSrc,
  aj: ajSrc,
  bh: bhSrc,
  cg: cgSrc,
  gn: gnSrc,
  jo: joSrc,
  np: npSrc,
  ad: adSrc
}; // {code: "bj", label: "Benin"}
// {code: "ng", label: "Nigeria"}
// {code: "et", label: "Ethopia"}
// {code: "aj", label: "Ajman"}
// {code: "bh", label: "Bahrain"}
// {code: "cg", label: "Congo"}
// {code: "gn", label: "Guinea"}

const CountryFlag = props => {
  const {
    code,
    className
  } = props;
  return /*#__PURE__*/React.createElement("img", {
    src: countryMap[code],
    alt: code,
    className: cx(className)
  });
};

CountryFlag.propTypes = {
  code: PropTypes.oneOf(Object.keys(countryMap)).isRequired,
  className: PropTypes.string
};
CountryFlag.defaultProps = {
  className: null
};

const _default = /*#__PURE__*/React.memo(CountryFlag);

export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(countryMap, "countryMap", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/components/CountryFlag/CountryFlag.jsx");
  reactHotLoader.register(CountryFlag, "CountryFlag", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/components/CountryFlag/CountryFlag.jsx");
  reactHotLoader.register(_default, "default", "/root/local/TeamCity/buildAgent/work/bac1af6cbd11267e/src/components/CountryFlag/CountryFlag.jsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();